import { LANGUAGES } from "@/constants/languages";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const GROUPS = ["Indian", "International"];

export default function LanguagePicker({
  value,
  onChange,
  placeholder = "Pick a language",
  triggerClassName = "",
  testid = "language-picker",
}) {
  return (
    <Select value={value || "en"} onValueChange={onChange}>
      <SelectTrigger className={triggerClassName} data-testid={testid}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {GROUPS.map((group) => (
          <SelectGroup key={group}>
            <SelectLabel>{group}</SelectLabel>
            {LANGUAGES.filter((l) => l.group === group).map((l) => (
              <SelectItem key={l.code} value={l.code} data-testid={`${testid}-${l.code}`}>
                {l.label}
              </SelectItem>
            ))}
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  );
}
